module.exports = __webpack_public_path__ + "img/logo.95fe0677.png";